var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import FormElement from './form-element';
var FormGroup = /** @class */ (function () {
    function FormGroup(config) {
        var _a;
        this.title = (_a = config.title) !== null && _a !== void 0 ? _a : null;
        this.items = config.items;
        this.conditionalRender = config.conditionalRender;
    }
    FormGroup.prototype.shouldRender = function (values) {
        if (!this.conditionalRender) {
            return true;
        }
        return this.conditionalRender(values);
    };
    FormGroup.prototype.getVisibleElements = function (values) {
        return this.getElements().filter(function (element) { return element.shouldRender(values); });
    };
    FormGroup.prototype.getElements = function () {
        var elements = [];
        this.items.map(function (item) {
            if (item instanceof FormElement) {
                elements = __spreadArray(__spreadArray([], elements), [item]);
                return;
            }
            elements = __spreadArray(__spreadArray([], elements), item.getElements());
        });
        return elements;
    };
    return FormGroup;
}());
export default FormGroup;
